import { render, staticRenderFns } from "./main_dashboard.vue?vue&type=template&id=c20aa26c&scoped=true&"
import script from "./main_dashboard.vue?vue&type=script&lang=js&"
export * from "./main_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./main_dashboard.vue?vue&type=style&index=0&id=c20aa26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20aa26c",
  null
  
)

export default component.exports